// AssignmentView shows the items in an assignment
// AssignmentItemView shows an individual item in an assignment, which can then be completed

import React from 'react'
import { Row, Col, Card, CardHeader, CardBody, Table, Button } from 'reactstrap'
import arrayify from '../../helpers/arrayify'
import { Link } from 'react-router-dom'
import checkIfItemCompleted from '../../helpers/checkIfItemCompleted'

export default function AssignmentView (props) {

  let unitRows = <tr></tr>
  if (props.assignment) {
    const unitArray = arrayify(props.assignment.units)
    unitRows = unitArray.map( (unit, n) => {
      let unitStatus = 'Not Started'
      if (props.userAssignment.activity) {
        if (checkIfItemCompleted(unit.itemId, props.userAssignment.activity)) {
          unitStatus = 'Answered'
        }
      }
      return (
        <tr key={'unitRow' + n}>
          <td>
            <Link
              to={`/assignments/assignment/${props.assignment.assignmentId}/${unit.itemId}?item=${n + 1}`}
            >
              {`${unit.contentType} ${n + 1}`}
            </Link>
          </td>
          <td>{unit.itemType}</td>
          <td>{unitStatus}</td>
        </tr>
      )
    })
  }

  return (
    <Row>
      <Col>
        <Card>
          <CardHeader>
            {props.assignment ? props.assignment.assignmentName : 'Assignment' }
          </CardHeader>
          <CardBody>
            <Table>
              <thead>
                <tr>
                  <th>Unit</th>
                  <th>Type</th>
                  <th>Status</th>
                </tr>
                {unitRows}
              </thead>
            </Table>
            <Button>Continue Assignment</Button>
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentView.js